import lf from 'lovefield'

export function const_famillesengins_const_parametresmateriels (schemaBuilder) {
  schemaBuilder.createTable('const_famillesengins_const_parametresmateriels')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('const_famillesengins_id', lf.Type.INTEGER)
      .addColumn('const_parametresmateriels_id', lf.Type.INTEGER)
      .addPrimaryKey(['id'])
      // .addUnique('constFamillesengins_id', ['constFamillesengins_id', 'constOptions_id', 'constPhases_id'])
      // .addIndex('constFamillesengins_id', ['constFamillesengins_id', 'constParametresmateriels_id']);

}

/*
CREATE TABLE IF NOT EXISTS `const-famillesengins_const-parametresmateriels` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `const-famillesengins_id` int(11) NOT NULL,
  `const-parametresmateriels_id` int(11) NOT NULL,
  PRIMARY KEY (`id`),
  KEY `const-famillesengins_id` (`const-famillesengins_id`,`const-parametresmateriels_id`)
) ENGINE=InnoDB  DEFAULT CHARSET=utf8 AUTO_INCREMENT=7 ;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/constFamillesengins_constParametresmateriels.schema.js